import usePrivateAxios from '@/common/api/usePrivateAxios'
import { useMutation } from '@tanstack/react-query'
import { AxiosError } from 'axios'

type UseResetBranchGovernmentAllocationDistributionsProps = {
  onSuccess: () => void
  onError: (error: AxiosError) => void
  branchId: string
}

export const useResetBranchGovernmentAllocationDistributions = ({
  onSuccess,
  onError,
  branchId
}: UseResetBranchGovernmentAllocationDistributionsProps) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['resetGovernmentAllocationDistribution'],
    mutationFn: async (governmentAllocationId?: string) => {
      return privateAxios.put(`/billing/government_allocations/${governmentAllocationId}/reset_branch_remaining_distributions`, {
        branch_id: branchId
      })
    },
    onSuccess,
    onError,
  })
}
